import HeaderSearch from './thervumitra/HeaderSearch';
import { useMessages } from './thervumitra/i18n';
import { catalogUrl, dashboardUrl } from './thervumitra/links';
import VidyaNavLink from './thervumitra/vidya/NavLink';

// The learner dashboard's main menu in this site's header (customApp.tsx):
// Courses, Discover new, Vidya AI and the course search.
const HeaderNav = () => {
  const t = useMessages();
  return (
    <>
      <a className="nav-link" href={dashboardUrl()}>{t.lhCourses}</a>
      <a className="nav-link" href={catalogUrl('courses')}>{t.hdrDiscover}</a>
      <VidyaNavLink />
      <HeaderSearch />
    </>
  );
};

export default HeaderNav;
